<div *dxTemplate="let data of templateName">
    <div class="button-multiple-icon-container">
        <div *ngFor="let bData of getBeforeIcons(data)" class="inline-icons">
            <i *ngIf="bData" class="dx-icon padding-right" [ngClass]="bData"></i>
        </div>
        <div class="full-width">
            {{ getLabel(data) }}
        </div>
        <div *ngFor="let aData of getAfterIcons(data)" class="inline-icons">
            <i *ngIf="aData" class="dx-icon padding-left" [ngClass]="aData"></i>
        </div>
        <ng-content></ng-content>
    </div>
</div>
